import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


export const getCharacters = createAsyncThunk(
  "characters/getCharacters",
  async ({ get }) => {
      const response = await get("/webapp/characters/");

      for(let i=0; i<response.length; i++){
        const character = response[i];
        if(character.processing){
          start3DCharacterPolling({ id: character.id, get });
        }
      }

      return response;
  }
);

export const getCharacter = createAsyncThunk(
  "characters/getCharacter",
  async ({ id, get }) => {
    const response = await get(`/webapp/characters/2d/${id}/`);
    return response;
  }
);

export const get3DCharacter = createAsyncThunk(
  "characters/get3DCharacter",
  async ({ id, get }) => {
    const response = await get(`/webapp/characters/3d/${id}/`);
    return response;
  }
);

export const getCharacterLoras = createAsyncThunk(
  "loras",
  async ({ get }) => {
    const response = await get(`/webapp/loras`);
    return response;
  }
);

let intervals = {};

export const startCharacterPolling =
  ({ id, get }) =>
  (dispatch) => {
    if (intervals[id]) {
      return;
    }

    const interval = setInterval(async () => {
      try {
        const character = await dispatch(getCharacter({ id, get })).unwrap();
        if (character && !character.variants[0].processing) {
          dispatch(getCharacters({ get }));
          clearInterval(interval);
          delete intervals[id];
        }
      } catch (error) {
        console.error("Error fetching character:", error);
        clearInterval(interval);
        delete intervals[id];
      }
    }, 5000);

    intervals[id] = interval;
    console.log(`Polling started for character ID: ${id}`);

    dispatch(getCharacters({ get }));
  };

export const start3DCharacterPolling =
  ({ id, get }) =>
  (dispatch) => {
    if (intervals[id]) {
      return;
    }

    const interval = setInterval(async () => {
      try {
        const character = await dispatch(get3DCharacter({ id, get })).unwrap();
        console.log(character);
        if (character && !character.processing) {
          dispatch(getCharacters({ get }));
          clearInterval(interval);
          delete intervals[id];
        }
      } catch (error) {
        console.error("Error fetching character:", error);
        clearInterval(interval);
        delete intervals[id];
      }
    }, 5000);

    intervals[id] = interval;
    console.log(`Polling started for character ID: ${id}`);

    dispatch(getCharacters({ get }));
  };


const charactersSlice = createSlice({
  name: "characters",
  initialState: {
    items: [],
    status: "idle",
    error: null,
  },
  reducers: {
    deleteCharacter: (state, action) => {
      const id = action.payload;
      state.items = state.items.filter((character) => character.id !== id);
    },
    updateCharacter: (state, action) => {
      const { id, data } = action.payload;
      const index = state.items.findIndex((character) => character.id === id);

      if (index !== -1) {
        state.items[index] = { ...state.items[index], ...data };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCharacters.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCharacters.fulfilled, (state, action) => {
        state.status = "succeeded";

        let newCharacters = [];

        if (Array.isArray(action.payload)) {
          newCharacters = action.payload.filter(
            (newCharacter) =>
              !state.items.some(
                (existingCharacter) => newCharacter.id === existingCharacter.id
              )
          );

          // Actualizar personajes existentes
          action.payload.forEach((updatedCharacter) => {
            const index = state.items.findIndex(
              (character) => character.id === updatedCharacter.id
            );
            if (index !== -1) {
              state.items[index] = {
                ...state.items[index],
                ...updatedCharacter,
              };
            }
          });
        }
        // Caso donde `payload` tiene un campo `items`
        else if (action.payload && Array.isArray(action.payload.items)) {
          newCharacters = action.payload.items.filter(
            (newCharacter) =>
              !state.items.some(
                (existingCharacter) => newCharacter.id === existingCharacter.id
              )
          );

          action.payload.items.forEach((updatedCharacter) => {
            const index = state.items.findIndex(
              (character) => character.id === updatedCharacter.id
            );
            if (index !== -1) {
              state.items[index] = {
                ...state.items[index],
                ...updatedCharacter,
              };
            }
          });
        } else {
          console.error("Error: el payload no contiene un array válido");
          return;
        }

        state.items = [...newCharacters, ...state.items];
      })
      .addCase(getCharacters.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { deleteCharacter } = charactersSlice.actions;
export default charactersSlice.reducer;
